import React, { createContext, useEffect, useState } from 'react'
import { Tracker } from '~/components/Tracker'

import { api, authHeaders } from '~/services/api'

import { descriptografar } from '~/util/crypto'

export const GlobalContext = createContext()

export const trackableProfiles = [9, 11, 27, 28, 29, 30, 31, 33] // [4, 5, 8, 9, 11, 12, 13, 14]

const GlobalProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [sessionId, setSessionId] = useState(null)

    useEffect(() => {
        const storedUser = descriptografar(sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_USER))

        if (storedUser) {
            setUser(storedUser)
        } else {
            setUser(null)
        }
    }, [])

    async function reload() {
        if (user) {
            const response = await api.get('usuario', authHeaders())

            setUser({
                ...response,
                avatar: response.avatar.link
            })
        }
    }

    return (
        <GlobalContext.Provider value={{
            user,
            setUser,
            reload,
            sessionId,
            setSessionId
        }}
        >
            {children}

            {user && trackableProfiles.includes(user.perfil.id) && <Tracker />}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider
